import React from "react";

class Page4 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 3) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div>
            <div className="container-fluid h-100 vertical-center ">
              <div className="row h-100 justify-content-center">
                <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                  <div className="card mb-4 box-shadow" id="pageContent">
                    <div className="card-body d-flex flex-column text-dark">
                      <span id="moduleContentText_2">
                        <p>
                          Careful career planning works for many people,
                          especially when it includes getting to know yourself
                          and your strengths and by researching options and
                          opportunities. However… for some people, unplanned
                          events or chance occurrences have just as big a role
                          to play in life and career choices as careful planning
                          does. This is where the theory of{" "}
                          <a
                            target="_blank"
                            href="https://www.careers.govt.nz/resources/career-practice/career-theory-models/krumboltzs-theory/"
                          >
                            ‘planned happenstance’
                          </a>{" "}
                          by Krumboltz comes into play.
                        </p>
                        <br />
                        <center>
                          <p>The term deconstructed:</p>
                        </center>
                        <br />
                        <center>
                          <p>
                            <strong>Planned</strong> (having arranged the parts)
                            + <strong>Happen</strong> (to occur by chance) +{" "}
                            <strong>Stance</strong> (a view or attitude)
                          </p>
                        </center>
                        <br />
                        <p>
                          In a nutshell, Krumboltz suggests that a career is
                          something that will gradually unfold and encourages
                          you to make the most of opportunities as they arise.
                          It could be you are trying too hard to rationalise
                          your thinking. Instead, actively seek out and explore
                          new career ideas and pursue interesting things as they
                          arise. For example the more people you speak to, the
                          more likely you are to find out about ways into what
                          it is you want to do.
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page4;
